import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProviderGroup } from 'carehub-api/models/providergroup/providergroup';
import { ProviderGroupsApiService } from 'carehub-api/providergroups-api.service';
import { Guid } from 'carehub-shared/guid';
import { Observable } from 'rxjs';

@Component({
  templateUrl: './providergroup.component.html',
  styleUrls: ['./providergroup.component.scss'],
})
export class ProviderGroupComponent implements OnInit {
  providerGroup$: Observable<ProviderGroup>;

  menuItems: { displayName: string; routeName: string }[] = [
    {
      displayName: 'DETAILS',
      routeName: 'details',
    },
    {
      displayName: 'DOCUMENTS',
      routeName: 'documents',
    },
    {
      displayName: 'PHYSICIANS',
      routeName: 'providers',
    },
    {
      displayName: 'CONTRACTS',
      routeName: 'contracts',
    },
    {
      displayName: 'CONTACTS',
      routeName: 'contacts',
    },
    {
      displayName: 'CLINICS',
      routeName: 'clinics',
    },
    {
      displayName: 'HISTORY',
      routeName: 'history',
    },
  ];

  constructor(
    public route: ActivatedRoute,
    private service: ProviderGroupsApiService
  ) {}

  ngOnInit() {
    var providerGroupId = this.route.snapshot.params.id;
    if (providerGroupId && providerGroupId !== Guid.empty) {
      this.providerGroup$ = this.service.getProviderGroupById(providerGroupId);
    }
  }
}
